import { RootState } from "../../../store";
import { resourceExplorerStateSelector } from "../resourceExplorerStateSelector";

export const resourceExplorerIdSelector = (state: RootState): string => {
  return resourceExplorerStateSelector(state).id;
};
